import { get_axios_instance, api_variables, errorHandler, get_axios_file_download_instance, get_axios_nest_instance, api_nest_variables } from '@/apis/variables.js';

var axios_instance = get_axios_instance(api_variables.SERVICE_FNF);
var axios_instance_fnf_get = get_axios_instance(api_variables.SERVICE_FNF_GET_DATA);
var axios_instance_fnf_pending = get_axios_instance(api_variables.SERVICE_FNF_PENDING);
var axios_instance_fnf_processed = get_axios_instance(api_variables.SERVICE_FNF_PROCESSED);
var axios_instance_get_reporting_manager = get_axios_instance(api_variables.SERVICE_FETCH_EMPBYID);
var axios_instance_get_days = get_axios_instance(api_variables.SERVICE_FNF_CALCULATE_DAYS);
var axios_instance_download_template = get_axios_instance(api_variables.SERVICE_DOWNLOAD_FNF_TEMPLATE);
var axios_instance_upload_template = get_axios_instance(api_variables.SERVICE_UPLOAD_FNF_TEMPLATE);
var axios_instance_fnf_gratuity_amount_get = get_axios_instance(api_variables.SERVICE_FNF_GRATUITY_PAY);
var axios_instance_update_gratuity_amount = get_axios_instance(api_variables.SERVICE_UPDATE_GRATUITY_AMOUNT);
var axios_instance_reset_fnf = get_axios_instance(api_variables.SERVICE_RESET_FNF);
var axios_instance_download_bulk_fnf_revoke = get_axios_instance(api_variables.SERVICE_DOWNLOAD_FNF_REVOKE_TEMPLATE);
var axios_instance_upload_bulk_fnf_revoke = get_axios_instance(api_variables.SERVICE_UPLOAD_FNF_REVOKE_TEMPLATE);
var axios_instance_fnf_payslip = get_axios_nest_instance(api_nest_variables.SERVICE_FNF_PAYSLIP);
var axios_instance_fnf_popup = get_axios_nest_instance(api_nest_variables.SERVICE_FNF_POPUP);

const _pk_name = "id";

const state = {
  data:[],
  pending: [],
  processed: [],
  exits: {},
  editMode: false,
  record: {},
  isFetching: false,
  isSaving: false,
  isDeleting: false
};

const getters = {
    editMode: (state) => {
        return state.editMode
    },
    record: (state) => {
        return state.record
    }
}

const mutations = {
  set: (state, payload) => {
    state.data = payload;
    //console.log('fetched data', state.data)
  },

  setPending: (state, payload) => {
    state.pending = payload;
    //console.log('fetched data', state.pending)
  },

  setProcessed: (state, payload) => {
    state.processed = payload;
    //console.log('fetched data', state.processed)
  },

  setExits: (state, payload) => {
    if(payload) {
      state.exits = payload;
    }
    //console.log('fetched exits', state.exits)
  },
  setFetching: (state, payload) => {
    state.isFetching = payload;
  },

  setSaving: (state, payload) => {
    state.isSaving = payload;
  },

  setDeleting: (state, payload) => {
    state.isDeleting = payload;
  },

  setEditMode: (state, payload) => {
      state.editMode = payload.editMode;
      state.record = payload.record;
  }
}

const actions = {
  async fetchAll({commit}, payload) {
      //console.log("[state/dashboard/organisation/processfnf/fetchAll] Calling API...",payload);
    try {
      commit("setFetching", true);
      let res = await axios_instance_fnf_get.get(`/`, {
        params: payload
      });

      commit("setFetching", false);
      //console.log("[state/dashboard/organisation/processfnf/fetchAll] res: ", res);
    //   if(res.status == 200) {
    //     commit("set", payload);
    //   }
     commit("set", res.data.rows);
      return res;
    }catch (err){
        //console.log(err);
    }
  },

  async fetchPending({commit}, payload) {
      //console.log("[state/dashboard/organisation/processfnf/fetchAll] Calling API...",payload);
    try {
      commit("setFetching", true);
      let res = await axios_instance_fnf_pending.get(`/`, {
        params: payload
      });

      commit("setFetching", false);
      //console.log("[state/dashboard/organisation/processfnf/fetchAll] res: ", res);
    //   if(res.status == 200) {
    //     commit("set", payload);
    //   }
     commit("setPending", res.data.payload.data);
      return res;
    }catch (err){
        //console.log(err);
    }
  },

  async fnfPayslipsPopup({commit}, payload) {
    //console.log("[state/dashboard/organisation/processfnf/fetchAll] Calling API...",payload);
  try {
    commit("setFetching", true);
    let res = await axios_instance_fnf_popup.post(`/`, payload);

    commit("setFetching", false);
    //console.log("[state/dashboard/organisation/processfnf/fetchAll] res: ", res);
  //   if(res.status == 200) {
  //     commit("set", payload);
  //   }
  //  commit("setProcessed", res.data.payload.data);
    return res;
  }catch (err){
      //console.log(err);
  }
},

  async fetchProcessed({commit}, payload) {
      //console.log("[state/dashboard/organisation/processfnf/fetchAll] Calling API...",payload);
    try {
      commit("setFetching", true);
      let res = await axios_instance_fnf_processed.get(`/`, {
        params: payload
      });

      commit("setFetching", false);
      //console.log("[state/dashboard/organisation/processfnf/fetchAll] res: ", res);
    //   if(res.status == 200) {
    //     commit("set", payload);
    //   }
     commit("setProcessed", res.data.payload.data);
      return res;
    }catch (err){
        //console.log(err);
    }
  },

  async fetchReportingManager({commit}, payload) {
    //console.log("[state/dashboard/organisation] Calling API...",payload);
  try {
    commit("setFetching", true);
    let res = await axios_instance_get_reporting_manager.get(`/`, {
      params: payload
    });

    commit("setFetching", false);
    //console.log("[state/dashboard/organisation] res: ", res);
  //   if(res.status == 200) {
  //     commit("set", payload);
  //   }s
    return res;
  }catch (err){
      //console.log(err);
  }
},

async fetchFnfDays({commit}, payload) {
  //console.log("[state/dashboard/organisation] Calling API...",payload);
try {
  commit("setFetching", true);
  let res = await axios_instance_get_days.get(`/`, {
    params: payload
  });

  commit("setFetching", false);
  //console.log("[state/dashboard/organisation] res: ", res);
//   if(res.status == 200) {
//     commit("set", payload);
//   }s
  return res;
}catch (err){
    //console.log(err);
}
},

async fetchFnfGratuityPay({commit},payload) {
   try{
       commit("setFetching", true);
       let res = await axios_instance_fnf_gratuity_amount_get.get(`/`, {
        params: payload 
       });

       commit("setFetching", false);
      //console.log("res:", res);
      return res;
   }catch (error) {
    //console.log(error);
   }
},

  async create({commit}, payload) {
      //console.log("[state/dashboard/organisation/processfnf/create] Adding...", payload);
    try {
      commit("setSaving", true);
      let res = await axios_instance.post('/', payload);
      commit("setSaving", false);
      //console.log("[state/dashboard/organisation/processfnf/create] res: ", res);
      // if(res.status == 200) {
      //   commit("addEmployee", payload);
      // }
      return res;
    }catch (err){
        //console.log(err);

    }
  },

  async update({commit}, payload) {
      //console.log("[state/dashboard/organisation/processfnf/update] Updating... Display payload", payload);
    try {
      commit("setSaving", true);
      // let res = await axios_instance.put(`/${payload.data.employee_id}`, payload);
      let res = await axios_instance.put('/', payload);
      commit("setSaving", false);
      //console.log("[state/dashboard/organisation/processfnf/update] res: ", res);
      // if(res.status == 200) {
      //   commit("updateEmployeeById", res.data);
      // }
      return res;
    }catch (err){
      throw errorHandler(err.response)
    }
  },

  async delete({commit}, payload) {
    //console.log("[state/dashboard/organisation/processfnf/delete] Payload:", payload);
    //console.log("[state/dashboard/organisation/processfnf/delete] Payload:", `/${payload.id}`);
    try {
      commit("setDeleting", true);
      let res = await axios_instance.delete(`/${payload.id}`);
      commit("setDeleting", false);
      if (res.status == 200){
        commit("removeEmployeeById", payload.id);
      }
    }catch (err){
        //console.log(err);

    }
  },

  async changeEditMode({ commit }, payload) {
      //console.log("[state/onboard/business_units/changeEditMode] Payload:", payload);
      try {
          commit("setEditMode", payload);
      } catch (error) {
          //console.log('error', error.response);
          throw errorHandler(error.response);
      }
  },

  async getEmployeeTemplate({commit},payload) {
    try {
        //console.log("Inside Report.js");
      let res = await axios_instance_download_template.get(`/`, {
        params: payload
      });
     // let res = await axios_instance_download_revise_salary.get(`/${payload}`);
      //console.log(res);

      if (res.data.status) {
        const link = document.createElement("a");
        //console.log(res);
        link.href = res.data.payload;
        link.setAttribute("download", "salaryRevisionTemplate"+ ".xlsx"); //or any other extension
        document.body.appendChild(link);
        link.click();
    }
    } catch (err) {
        throw errorHandler(error);
    }
  },

  async uploadTemplate({ commit }, payload) {
    try {
        // commit("setFetching", true);
        let res = await axios_instance_upload_template.post(``,payload);
        // commit("setFetching", false);
        return res;
    } catch (err) {
        throw errorHandler(err.response);
    }
},

async downloadFnfPayslip({ commit }, payload) {
  try {
      let res = await axios_instance_fnf_payslip.post(``, payload);

      // //console.log("Checking",res);
      // //console.log("Checking Blob--> ",res.data);
      // //console.log("Checking Data",typeof res.data);
      
      return res
    } catch (error) {
      throw errorHandler(error.response);
    }
  },

  async updateGratuityAmount({ commit }, payload) {
    try {
      commit("setSaving", true);
      let res = await axios_instance_update_gratuity_amount.put('', payload);
      commit("setSaving", false);
      return res;
    }catch (err){
      throw errorHandler(err.response)
    }
  },

  async resetFnf({ commit }, payload){
    try {
      commit("setSaving", true);
      let res = await axios_instance_reset_fnf.post('', payload);
      commit("setSaving", false);
      return res;
    }catch (err){
      throw errorHandler(err.response)
    }
  },

  async getBulkRevokeTemplate({commit},payload) {
    try {
      let res = await axios_instance_download_bulk_fnf_revoke.get(`/`, {
        params: payload
      });
      if (res.data.status) {
        const link = document.createElement("a");
        link.href = res.data.payload;
        link.setAttribute("download", "FNF Revoke"+ ".xlsx"); //or any other extension
        document.body.appendChild(link);
        link.click();
    }
    } catch (err) {
        throw errorHandler(err);
    }
},

async uploadFnfRevokeTemplate({ commit }, payload) {
    try {
        commit("setFetching", true);
        let res = await axios_instance_upload_bulk_fnf_revoke.post(``, payload);
        commit("setFetching", false);
        return res;
    } catch (err) {
        throw errorHandler(err.response);
    }
},
}

export default {
  namespaced: true,
  state, mutations, actions, getters
}
